module.exports = __webpack_public_path__ + "static/media/pataworld.a07abf5d.png";